<template>
  <div class="combo-box" :class="boxClass">
    <label class="combo-label">{{ label }}</label>
    <div
      @click="
        open = true
        focusInput()
      "
      class="fields"
    >
      <div class="field-container">
        <div v-if="checked.length > 0" class="chip-row">
          <div v-for="(item, idx) in checked" :key="idx" class="chip">
            {{ item }}
          </div>
        </div>
        <input
          ref="input"
          type="text"
          :readonly="!typable"
          v-model="comboText"
          @input="emitInput"
        />
      </div>
      <div v-if="open" class="field-dropdown">
        <div
          v-for="(item, idx) in items"
          :key="idx"
          class="field-item"
          :class="{ checked: isChecked(item) }"
          @click="checkItem(item)"
        >
          <div v-if="multiple" class="field-checkbox">
            <input type="checkbox" :name="item" :checked="isChecked(item)" />
            <label :for="item" />
          </div>
          <div class="field-name">{{ item }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uuid from 'uuid4'

export default {
  beforeDestroy() {
    window.removeEventListener('click', this.close)
  },
  data() {
    return {
      boxClass: `combo-box-${uuid()}`,
      checked: [],
      comboText: '',
      open: false,
    }
  },
  methods: {
    checkItem(item) {
      if (this.multiple) {
        if (this.isChecked(item)) {
          this.checked = this.checked.filter((c) => c !== item)
        } else {
          this.checked = this.checked.concat([item])
        }
      } else {
        this.checked = [item]
        this.open = false
      }

      this.emitInput()
    },
    close(e) {
      let eventPath = e.path || (e.composedPath && e.composedPath())
      if (
        !eventPath.find((el) => {
          return el.className === `combo-box ${this.boxClass}`
        })
      ) {
        this.open = false
      }
    },
    emitInput() {
      this.$emit('input', this.rollup())
    },
    focusInput() {
      if (this.typable) this.$refs.input.focus()
    },
    isChecked(item) {
      return this.checked.includes(item)
    },
    rollup() {
      let text = this.comboText.split(',').filter((t) => t.length > 0)
      return text.length > 0 ? this.checked.concat(text) : this.checked
    },
  },
  mounted() {
    if (this.typable) {
      ;(this.value || []).forEach((v) => {
        if (['clients', 'BUYERS'].includes(v)) {
          this.checked.push('clients')
        } else if (['inspectors', 'INSPECTORS'].includes(v)) {
          this.checked.push('inspector')
        } else if (['client agent', 'BUYING_AGENT'].includes(v)) {
          this.checked.push('client agent')
        } else if (['selling agent', 'SELLING_AGENT'].includes(v)) {
          this.checked.push('selling agent')
        } else if (['company admins', 'COMPANY_ADMINS'].includes(v)) {
          this.checked.push('company admins')
        } else if (['inspector', 'company'].includes(v)) {
          this.checked.push(v)
        } else {
          if ((this.comboText || '').length === 0) {
            this.comboText += v
          } else {
            this.comboText += `,${v}`
          }
        }
      })
    } else if (!this.multiple) {
      if (this.value) this.checked = [this.value]
    } else {
      this.checked = this.value || []
    }
    window.addEventListener('click', this.close)
  },
  props: ['items', 'label', 'typable', 'multiple', 'value'],
}
</script>

<style scoped>
.combo-label {
  display: block;
}

.field-container {
  display: flex;
  overflow-x: hidden;
  flex-wrap: nowrap;
}

.chip-row,
.chip {
  display: inline-block;
}

.chip-row {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
}

.fields {
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  border-bottom: 1px solid #bbb;
}

.fields input {
  width: auto;
  outline: none;
  background-color: inherit;
  border: none;
  flex-grow: 0;
}

.fields .field-dropdown {
  position: absolute;
  top: 3rem;
  left: 0;
  z-index: 10;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.field-dropdown .field-item {
  cursor: pointer;
  display: flex;
  padding: 1em;
  color: rgba(0, 0, 0, 0.87);
  transition: background 0.1s linear;
  background-color: #fff;
}

.field-dropdown .field-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.field-dropdown .field-item.checked {
  color: #5c9ccf;
}

.field-item .field-checkbox,
.field-item .field-name {
  display: inline-block;
}
</style>
